function ampSyncCartCounts (count) {
//const headerCartCount = document.querySelector('.nav-item a.current-cart span.cart-count');
const headerCartCount = document.querySelector('hdt-cart-count'); // new cart count selector

if (headerCartCount) {
    headerCartCount.textContent = count;
    
    if (count > 0) {
    headerCartCount.classList.remove('hidden');
    } else {
    headerCartCount.classList.add('hidden');
    }
}
}

function ampHideGiftQuantityButtons () {
// hide quantity selector for gifts
const cartItemPrices = document.querySelectorAll('.amp-cart-drawer .amp-cart__cart-line .amp-cart__cart-line-price, .amp-cart-drawer .amp-cart__cart-line .amp-cart__cart-line-price .amp-cart__cart-line-price--discounted');

cartItemPrices.forEach(price => {
    const priceParent = price.closest('.amp-cart__cart-line-details-bottom');
    
    if (priceParent) {
    const quantitySelector = priceParent.querySelector('.amp-cart__line-quantity-selector');
    
    if (quantitySelector) {
        if (price.textContent === '$0.00') {
        quantitySelector.style.display = 'none';
        priceParent.style.justifyContent = 'flex-end';
        } else {
        quantitySelector.style.display = 'flex';
        priceParent.style.justifyContent = 'space-between';
        }
    }
    }
});
}

function ampCheckFreeGift (cart, cartTarget) {
// automatically remove gift if price falls below threshold
cartTarget.blocks.forEach(block => {
    if (block.type === 'CartRewardsBlock' && block.enabled) {
    block.content.tiers.forEach(tier => {
        if (tier.type === 'FreeGift') {
        const giftThreshold = tier.trigger;
        const giftThresholdConverted = giftThreshold * Shopify.currency.rate;
        const giftHandle = tier.freeGift.handle;
        
        if (cart.total_price/100 < giftThresholdConverted) {
            cart.items.forEach(item => {
            if (item.handle === giftHandle) {
                const variantId = item.variant_id;
                let updates = { [variantId]: 0};
                
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
                })
                .catch((error) => {
                console.error('Error:', error);
                });
            }
            });
        }
        }
    });
    }
});
}

document.addEventListener("click", (e) => {
    const btn = e.target.closest('[name="add"]');
    if (!btn) return;

    setTimeout(() => {
        const modal = document.querySelector('#hdt-quick-add-modal');
        modal?.parentElement?.close?.();
        window.AMP_API?.OPEN_CART?.();
    }, 400);
});

window.AMP_CART_UPDATED = (cart, cartTarget) => {
ampSyncCartCounts(cart.item_count);
ampHideGiftQuantityButtons();
ampCheckFreeGift(cart, cartTarget);
}


/* ==================================================================
 * English text overrides for the AMP Upsell cart.
 *
 * The AMP Upsell app holds one set of strings per store, and this
 * store's are written in zh-TW. The app has no locale switch, so the
 * English storefront is patched in the DOM instead.
 *
 * TO ADD OR EDIT A STRING
 *   Key   = the exact text the app renders, with any money amount
 *           written as {amount}. Paste the Chinese, do not retype it.
 *   Value = the English for /en, reusing {amount} where the figure goes.
 *
 * An unmatched string is left alone, so it stays in Chinese. If a
 * message is edited in the AMP app, its key here must be updated too.
 * ================================================================== */
(function () {
  var locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || '';

  // This file is loaded on every locale; the overrides are for /en only.
  if (locale.indexOf('en') !== 0) {
    return;
  }

  // Announcement bar, from the app's Announcements panel.
  var ANNOUNCEMENTS = {
    '🎉 全年最大減價優惠：所有 BOOMBA 產品買2送1！':
      '🎉 Biggest Sale of the Year: Buy 2, Get 1 FREE on All BOOMBA Products!',

    '消費滿 {amount}？記得喺下面加入你嘅免費禮物！':
      'Spent {amount}? Make sure to add your FREE gift below!',

    // '所有 BOOMBA 胸圍同隱形胸圍買一件，第二件享6折！隨意配搭。優惠碼：BOGO40 💛':
    //   'Buy 1, get 40% off the 2nd — all BOOMBA bras & invisible bras. Mix and match. Code: BOGO40 💛',

    '所有產品免費退換':
      'Free returns and exchanges on all products'
  };

  /*
   * Cart reward strings. HK runs two reward tiers and each tier has its own
   * wording for all three lines, so these are keyed by the source text.
   * Keying by CSS selector instead gives every tier the same English - that
   * is what made both progress-bar milestones read "Free shipping" and hid
   * the Care Kit tier completely.
   */
  var REWARDS = {
    // Progress-bar tier labels.
    '免運費':               'Free shipping',
    'BOOMBA 保養套裝':      'BOOMBA Care Kit',
    '免費贈送 魔術矽膠乳貼': 'Free Magic Nipple Covers',

    // "Spend a bit more" line, for the next tier not yet reached.
    '買多{amount} 即享免運費優惠':            'Spend {amount} more for free shipping',
    '買多{amount} 即可獲贈 BOOMBA 保養套裝':  'Spend {amount} more for a free BOOMBA Care Kit',
    '買多{amount} 即可獲贈魔術矽膠乳貼':      'Spend {amount} more for a free Magic Nipple Covers',

    // Tier reached.
    '可享免運費優惠！':         "You've unlocked free shipping!",
    'BOOMBA 保養套裝 applied!': 'BOOMBA Care Kit applied!',
    '免費贈送 魔術矽膠乳貼 applied!': 'Free Magic Nipple Covers applied!'
    //
  };

  var SELECTORS = [
    '.amp-cart__announcement-slide-content',
    '.amp-cart__rewards-current-reward',
    '.amp-cart__rewards-progress-bar-tier-milestone-label',
    '.amp-cart__rewards-applied-reward'
  ].join(',');

  var MONEY = /(?:[A-Z]{0,3}\s?[$€£¥]|[$€£¥])\s?[\d,]+(?:\.\d+)?/;

  function norm(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  // One normalised lookup, so stray whitespace in an app value still matches.
  var DICT = {};

  Object.keys(ANNOUNCEMENTS).forEach(function (key) {
    DICT[norm(key)] = ANNOUNCEMENTS[key];
  });

  Object.keys(REWARDS).forEach(function (key) {
    DICT[norm(key)] = REWARDS[key];
  });

  function translateNode(el) {
    var live = norm(el.textContent);

    /*
     * The app re-renders these nodes in Chinese every time the cart changes,
     * with a new amount and sometimes a different tier. Anything that is not
     * our own last output is therefore a fresh source string to re-learn -
     * trusting a once-captured source would freeze a stale amount on screen.
     */
    if (live !== el.dataset.ampOut) {
      el.dataset.ampSrc = live;
    }

    var source = el.dataset.ampSrc || live;
    var template = DICT[source.replace(MONEY, '{amount}')];

    if (!template) {
      return;
    }

    var amount = (source.match(MONEY) || [''])[0].trim();
    var english = template.replace('{amount}', amount);

    if (english !== live) {
      el.textContent = english;
    }

    el.dataset.ampOut = english;
  }

  function translateCart() {
    var nodes = document.querySelectorAll(SELECTORS);

    for (var i = 0; i < nodes.length; i++) {
      translateNode(nodes[i]);
    }
  }

  var queued = false;

  /*
   * Coalesce a burst of mutations into one pass. This deliberately uses a
   * timer rather than requestAnimationFrame: rAF is suspended entirely while
   * the tab is in the background, which would leave `queued` stuck at true
   * and kill the overrides for the rest of the page's life, even after the
   * shopper returns to the tab. Timers are throttled when hidden, never paused.
   */
  function queueTranslate() {
    if (queued) {
      return;
    }

    queued = true;

    setTimeout(function () {
      queued = false;
      translateCart();
    }, 0);
  }

  function start() {
    translateCart();

    new MutationObserver(queueTranslate).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();
})();
